/* ============================================================
   Offers Drawer — Slide-out panel (follows cart-drawer pattern)
   ============================================================ */

if (!customElements.get('offers-drawer')) {
  class OffersDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('.offers-drawer');
      this.overlay = this.querySelector('.offers-drawer__overlay');
      this.closeBtn = this.querySelector('.offers-drawer__close');
      this.triggerBtn = this.querySelector('.offers-drawer__trigger');
      this.activeElement = null;

      // Escape key closes drawer
      this.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });

      // Overlay click closes drawer
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }

      // Close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }

      // Trigger button
      if (this.triggerBtn) {
        this.triggerBtn.addEventListener('click', () => this.open(this.triggerBtn));
      }

      // Copy buttons
      this.querySelectorAll('.offers-drawer__copy-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.copyCode(btn);
        });
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.activeElement = triggeredBy;
      if (!this.drawer) return;

      this.drawer.classList.add('active');
      document.body.classList.add('overflow-hidden');

      // Trap focus after animation
      this.drawer.addEventListener(
        'transitionend',
        () => {
          const panel = this.querySelector('.offers-drawer__panel');
          const focusEl = this.closeBtn || panel;
          if (typeof trapFocus === 'function') {
            trapFocus(panel, focusEl);
          }
        },
        { once: true }
      );
    }

    close() {
      if (!this.drawer) return;

      this.drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }

      this.activeElement = null;
    }

    copyCode(btn) {
      const code = btn.dataset.code;
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const originalText = btn.textContent;
        btn.textContent = 'Copied!';
        btn.classList.add('offers-drawer__copy-btn--copied');

        setTimeout(() => {
          btn.textContent = originalText;
          btn.classList.remove('offers-drawer__copy-btn--copied');
        }, 2000);
      }).catch(() => {
        // Fallback: select the code input
        const codeEl = btn.closest('.offers-drawer__code-wrapper')
          ?.querySelector('.offers-drawer__code');
        if (codeEl) {
          codeEl.focus();
          if (codeEl.select) codeEl.select();
        }
      });
    }
  }

  customElements.define('offers-drawer', OffersDrawer);
}
